<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="'password'">
    <sn-password-control
      [id]="id"
      [formControl]="formControl"
      [field]="field"
      [tabindex]="templateOptions.tabindex || 0"
      [toggleMask]="templateOptions.toggleMask"
      [placeholder]="templateOptions.placeholder | t"
    >
    </sn-password-control>
  </ng-container>

  <ng-container *ngSwitchCase="'autocomplete-text'">
    <mat-chip-list #chipList>
      <mat-chip
        *ngFor="let item of items;let i = index;"
        [selectable]="true"
        [removable]="true"
        (removed)="removeItem(item, i)"
      >
        {{ item }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
      <input
        placeholder="{{ 'common.typeKeyword' | t }}"
        #chipInput
        [id]="id"
        [formControl]="inputControl"
        [tabindex]="templateOptions.tabindex || 0"
        [formlyAttributes]="field"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="addItem($event)"
      />
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option.key | lowercase">
        {{ option.key | lowercase }}
      </mat-option>
    </mat-autocomplete>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <input
      matInput
      [id]="id"
      [type]="type"
      [readonly]="templateOptions.readonly"
      [errorStateMatcher]="errorStateMatcher"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [tabindex]="templateOptions.tabindex || 0"
      [placeholder]="templateOptions.placeholder"
    />
  </ng-container>
</ng-container>
